export default __webpack_public_path__ + "static/media/profile-tournament.e3d35112.webp";